import useSectionComposition from './useSectionComposition'
import { useSectionGroupActions } from './useSectionGroupActions'

export type UseSectionGroupCallbacksParams = Parameters<
  typeof useSectionGroupActions
>[0]

export type UseSectionGroupCallbacksResult = ReturnType<
  typeof useSectionGroupActions
> &
  Pick<
    ReturnType<typeof useSectionComposition>,
    'handleComposition' | 'handleCreateGroup'
  >

export const useSectionGroupCallbacks = (
  params: UseSectionGroupCallbacksParams
): UseSectionGroupCallbacksResult => {
  const composition = useSectionComposition(params)
  const groupActions = useSectionGroupActions(params)
  return {
    ...groupActions,
    handleComposition: composition.handleComposition,
    handleCreateGroup: composition.handleCreateGroup
  }
}
